<div class="modal-content">
  <div class="modal-header">
    <h4 class="modal-title font-weight-bold" id="exampleModalLabel1">
      Observación Final
    </h4>
    <button
      type="button"
      class="close"
      data-dismiss="modal"
      aria-label="Close"
      [mat-dialog-close]
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="container text-center">
    <div class="info-general-caso color">
      <div class="divtext">
        <b class="textWidth">Número de Caso:</b>
        <p class="textor">{{ caso.numero_caso }}</p>
      </div>
      <div class="divtext">
        <b class="textWidth">Unidad:</b>
        <p class="textor">{{ caso.unidad }}</p>
      </div>
      <div class="divtext">
        <b class="textWidth">Tipo de Caso:</b>
        <p class="textor">{{ caso.tipo_caso }}</p>
      </div>
      <div class="divtext">
        <b class="textWidth">Analista</b>
        <p class="textor">{{ caso.asignadoA }}</p>
      </div>
      <div class="divtext">
        <b class="textWidth">Fecha de Creación:</b>
        <p class="textor">{{ caso.createdAt | date: "d/M/yy" }}</p>
      </div>
      <div class="divtext">
        <b class="textWidth">Última Modificación:</b>
        <p class="textor">{{ caso.updatedAt | date: "d/M/yy" }}</p>
      </div>
      <div class="divtext">
        <b class="textWidth">Creado Por:</b>
        <p class="textor">{{ caso.creadoPorc }}</p>
      </div>
      <div class="divtext">
        <b class="textWidth">Tareas Finalizadas:</b>
        <p class="textor">{{ tareaFinalizadas }}</p>
      </div>
      <div class="divtext">
        <b class="textWidth">Descripción: </b>
        <p style="width: 232px" class="textor descr">{{ caso.descripcion }}</p>
      </div>
      <!-- <br>
      <br>
      <br>
      <br>
      <br>
      <br>
      <br> -->
    </div>
    <!-- 
    <div class="descripcion_tarea mt-3">
      <b>Descripción: </b> <p class="textor">{{ caso.descripcion }}</p>

    </div> -->

    <form [formGroup]="form" class="formulario mt-5">
      <mat-form-field class="matform" appearance="outline">
        <mat-label>Observaciones</mat-label>
        <textarea matInput formControlName="observacion_final"></textarea>
      </mat-form-field>

      <!-- si se trata de una solicitud de validar documentos -->
      <div *ngIf="caso.tipo_caso == 'Validar Documento'">
        <!-- <div class="col-12 divCheck" >
          <p class="textoRadio">Documento valido</p>
            <mat-radio-group class="formRadio" formControlName="validar_documento" aria-label="Select an option">
              <mat-radio-button value="Si">Si</mat-radio-button>
              <mat-radio-button  style="margin-left:10px" value="No">No</mat-radio-button>
            </mat-radio-group>
          </div> -->
        <div class="row" *ngIf="form.value.validar_documento == 'Si'">
          <div class="divRadio col-6">
            <mat-form-field appearance="outline" class="dateInputValidacion">
              <mat-label>Fecha</mat-label>
              <input
                matInput
                formControlName="fecha_realizacion"
                [matDatepicker]="picker2"
              />
              <mat-datepicker-toggle
                matSuffix
                [for]="picker2"
              ></mat-datepicker-toggle>
              <mat-datepicker #picker2></mat-datepicker>
            </mat-form-field>
          </div>
          <div class="col-6">
            <mat-form-field style="width: 100%">
              <mat-label>Correo</mat-label>
              <input
                type="text"
                formControlName="email_usado"
                matInput
                placeholder="Ingrese su correo"
              />
              <mat-error *ngIf="form.get('email_usado').hasError('required')"
                >El correo es <strong>requerido</strong></mat-error
              >
              <mat-error *ngIf="form.get('email_usado').hasError('email')"
                >El correo es <strong>invalido</strong></mat-error
              >
            </mat-form-field>
          </div>
          <div class="col-12 divCheck">
            <p class="textoRadio">Solicitante informado por correo</p>
            <mat-radio-group
              class="formRadio"
              formControlName="informado_correo"
              aria-label="Select an option"
            >
              <mat-radio-button value="Si">Si</mat-radio-button>
              <mat-radio-button style="margin-left: 10px" value="No"
                >No</mat-radio-button
              >
            </mat-radio-group>
          </div>
        </div>
      </div>
      <!-- si se trata de una solicitud de Autorización de transacciones -->
      <div *ngIf="caso.tipo_caso == 'Autorización de transacciones'">
        <div class="col-12 divCheck">
          <p class="textoRadio">Autorizar</p>
          <mat-radio-group
            class="formRadio"
            formControlName="autorizar"
            aria-label="Select an option"
          >
            <mat-radio-button value="Si">Si</mat-radio-button>
            <mat-radio-button style="margin-left: 10px" value="No"
              >No</mat-radio-button
            >
          </mat-radio-group>
        </div>
        <div class="col-12 divCheck">
          <p class="textoRadio">Patron de fraude</p>
          <mat-radio-group
            class="formRadio"
            formControlName="patron_fraude"
            aria-label="Select an option"
          >
            <mat-radio-button value="Si">Si</mat-radio-button>
            <mat-radio-button style="margin-left: 10px" value="No"
              >No</mat-radio-button
            >
          </mat-radio-group>
        </div>
      </div>

      <!-- si se trata de una solicitud de Validación de referencias -->
      <div *ngIf="caso.tipo_caso == 'Validación de referencias'">
        <div class="row">
          <div class="divRadio col-6">
            <mat-form-field appearance="outline" class="dateInputValidacion">
              <mat-label>Fecha</mat-label>
              <input
                matInput
                formControlName="fecha_realizacion"
                [matDatepicker]="picker2"
              />
              <mat-datepicker-toggle
                matSuffix
                [for]="picker2"
              ></mat-datepicker-toggle>
              <mat-datepicker #picker2></mat-datepicker>
            </mat-form-field>
          </div>
          <div class="col-6">
            <mat-form-field style="width: 100%">
              <mat-label>Correo</mat-label>
              <input
                type="text"
                formControlName="email_usado"
                matInput
                placeholder="Ingrese su correo"
              />
              <mat-error *ngIf="form.get('email_usado').hasError('required')"
                >El correo es <strong>requerido</strong></mat-error
              >
              <mat-error *ngIf="form.get('email_usado').hasError('email')"
                >El correo es <strong>invalido</strong></mat-error
              >
            </mat-form-field>
          </div>
          <div class="col-12 divCheck">
            <p class="textoRadio">Solicitante informado por correo</p>
            <mat-radio-group
              class="formRadio"
              formControlName="informado_correo"
              aria-label="Select an option"
            >
              <mat-radio-button value="Si">Si</mat-radio-button>
              <mat-radio-button style="margin-left: 10px" value="No"
                >No</mat-radio-button
              >
            </mat-radio-group>
          </div>
        </div>
      </div>
    </form>

    <div class="text-center mt-4">
      <button class="btn-guardar" (click)="finalizarDelTodo()">
        Finalizar
      </button>
    </div>
  </div>
</div>
